import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  wishlistItemRemoveConfirmModal: { isOpen: false, data: null },
  notificationOnModal: { isOpen: false, data: null },
  removeFromWishlistModal: { isOpen: false, data: null },
  allItemsRemovedModal: { isOpen: false, data: null },
  wishlistNotification: { isOpen: false, data: null },
  commonModal: { isOpen: false, data: null },
};

const wishlistModalSlice = createSlice({
  name: 'wishlistModal',
  initialState,
  reducers: {
    toggleModal: (state, action) => {
      const { modalType, isOpen, data = null } = action.payload;
      if (state[modalType]) {
        const updatedData = {
          isOpen,
          data,
        };
        state[modalType] = updatedData;
      }
    },
  },
});

export const { toggleModal } = wishlistModalSlice.actions;
export default wishlistModalSlice.reducer;
